<template>
  <div class="is-pulled-right" :data-track="dataTrack">
    <span class="bar-chart-total-reviews">{{title}}</span>
    <div class="dropdown">
      <!-- Dropdown Trigger Begins -->
      <div class="dropdown-trigger">
        <button
          data-track="item.dataTrack"
          class="button button-dropdown bar-chart-dropdown"
          :class="[{'is-block': selectedOptions.length !== 1 }]"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          @click="handleClick"
        >
          <!-- If user selected only one rating -->
          <span class="is-size-7" v-if="selectedOptions.length === 1">
            <span class="chart-dropdown-rating"><rating class="is-pulled-left" :stars="rating"></rating></span>
            <span class="chart-dropdown-star">{{rating}} Stars</span>
          </span>
          <!-- If user selected multiple rating -->
          <span class="is-size-7" :class="[{'multiple-selections': selectedOptions.length > 1}]" v-else-if="selectedOptions.length > 1">
            Multiple Selections
          </span>
          <!-- If user selected no rating -->
          <span class="is-size-7" :class="[{'no-selections': !selectedOptions.length}]" v-else>
            No Selections
          </span>
          <i class="fas fa-angle-down" aria-hidden="true"></i>
        </button>
      </div> <!-- Dropdown Trigger Ends -->
      <div :class="[{'dropdown-view': showDropDown}, 'dropdown-menu padding-top-0 padding-bottom-0']" role="menu">
        <div class="dropdown-content is-paddingless">
          <div v-for="obj in ratings">
            <div class="columns is-mobile is-paddingless is-marginless rating-section">
              <div class="column is-12" :style="[!obj.rating ? {'padding-top': '8px'} : '']">
                <label class="checkbox is-size-6 label-filters">
                  <input
                    type="checkbox"
                    :value="obj.rating"
                    v-model="selectedOptions"
                    @change="handleChange"
                  >
                  <span class="checkmark"></span>
                  <span class="dropdown-text">{{obj.name}}</span>
                  <span class="chart-dropdown-rating is-pulled-right"><rating :stars="obj.rating" v-if="obj.rating"></rating></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
  import _ from 'lodash/array'
  import Rating from '@/components/Rating'

  export default {
    name: 'StarRatingFilter',
    components: {
      Rating
    },
    props: {
      title: {
        type: String,
        default: 'Star rating'
      },
      dataTrack: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        showDropDown: false,
        selectedOptions: [null, 1, 2, 3, 4, 5],
        rating: null,
        ratings: [
          {name: 'All star rating', rating: null},
          {name: '5 Star', rating: 5},
          {name: '4 Star', rating: 4},
          {name: '3 Star', rating: 3},
          {name: '2 Star', rating: 2},
          {name: '1 Star', rating: 1}
        ]
      }
    },
    methods: {
      /**
       * Handle the click event for Star Rating Dropdown
       * @return {void}
       */
      handleClick () {
        this.showDropDown = !this.showDropDown
      },
      /**
       * Handle the Dropdown change for Star Rating
       * @param {object} event
       * @return {void}
       */
      handleChange (event) {
        /** If All Star Rating is Checked, Check all options */
        if (!event.target.value && event.target.checked) {
          this.selectedOptions = [null, 1, 2, 3, 4, 5]
        }
        /** If All Star Rating is Unchecked, Uncheck all checked */
        if (!event.target.value && !event.target.checked) {
          this.selectedOptions = []
        }
        /** If All Star Rating is Checked and any other option is unchecked, uncheck All Star Rating too */
        if (event.target.value && !event.target.checked) {
          this.$delete(this.selectedOptions, _.indexOf(this.selectedOptions, null))
        }
        /** If Single Star Rating Selected */
        if (this.selectedOptions.length === 1) {
          this.rating = this.selectedOptions[0]
        }
        /** If any filter selected then array, otherwise null */
        this.$emit('onRatingFilterChange', this.selectedOptions.length ? this.selectedOptions : [null])
      }
    }
  }
</script>

<style scoped>
  .chart-dropdown-rating {
    font-size: 7px;
  }
  .chart-dropdown-star {
    font-size: 11px;
    margin-left: 13%;
  }
  .chart-dropdown-rating ul.width-180 {
    text-align: left !important;
    width: 77px !important;
  }
  .bar-chart .dropdown-trigger .is-size-7 {
    line-height: 0.9em;
    margin-right: auto;
    top: 35%;
    position: absolute;
    left: 8%;
  }
  .multiple-selections {
    margin-right: 39px !important;
  }
  .no-selections {
    margin-right: 68px !important;
  }
  .dropdown-trigger {
    min-width: 180px;
  }
  .bar-chart-dropdown {
    height: 40px;
    padding: 10px;
    position: relative;
  }
  .bar-chart-total-reviews {
    color: #58595b;
    font-size: 11px;
    font-weight: bold;
    margin-right: 10px;
  }
  .dropdown-view {
    z-index: 19;
    width: 180px;
    display: block;
    min-width: 100%;
  }
  .dropdown-view .dropdown-content {
    border: solid 1px rgb(219, 219, 219);
    margin-top: 2%;
    border-radius: 0;
  }
  .rating-section .column.is-12 {
    padding: 5px 14px;
  }
  .rating-section .column.is-12:not(first-child), .rating-section .column.is-12:not(last-child){
    padding: 0 14px;
  }
  .dropdown-text {
    margin: 0 10px;
    font-size: 12px;
    vertical-align: text-top;
  }
  .label-filters {
    line-height: 0.65;
  }
  .label-filters input {
    width: 17px;
    height: 17px;
    border: solid 1px #707070;
  }
  .label-filters .chart-dropdown-rating ul.width-180 {
    text-align: right !important;
  }
  is-block {
    display: block;
  }
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 17px;
    width: 17px;
    background-color: #fff;
    border: solid 1px #707070;
  }
  /* On mouse-over, add a grey background color */
  .label-filters:hover input ~ .checkmark {
    background-color: #fff;
  }
  /* When the checkbox is checked, add a blue background */
  .label-filters input:checked ~ .checkmark {
    border: none;
    background-color: #30aae1;
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the checkmark when checked */
  .label-filters input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the checkmark/indicator */
  .label-filters .checkmark:after {
    left: 7px;
    top: 2px;
    width: 5px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .bar-chart-dropdown .fa-angle-down {
    font-size: 1.5em;
    position: absolute;
    right: 7%;
    top: 22%;
  }
  .chart-dropdown-rating >>>img {
    height: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/StarRatingFilter.vue